/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type OAuthProvider =
  | 'GOOGLE'
  | 'MICROSOFT';

export type FetchCalendarStaffsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCalendarStaffsQuery = { staffsByPlanner: Array<{ guid: string, displayName: string, connectedThirdPartyProvider: Types.OAuthProvider | null }> };


export const FetchCalendarStaffsDocument = gql`
    query FetchCalendarStaffs {
  staffsByPlanner {
    guid
    displayName
    connectedThirdPartyProvider
  }
}
    `;

/**
 * __useFetchCalendarStaffsQuery__
 *
 * To run a query within a Vue component, call `useFetchCalendarStaffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCalendarStaffsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchCalendarStaffsQuery();
 */
export function useFetchCalendarStaffsQuery(options: VueApolloComposable.UseQueryOptions<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables>(FetchCalendarStaffsDocument, {}, options);
}
export function useFetchCalendarStaffsLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables>(FetchCalendarStaffsDocument, {}, options);
}
export type FetchCalendarStaffsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchCalendarStaffsQuery, FetchCalendarStaffsQueryVariables>;